<template>
  <div class="task-list krs006">    
    <div class="output_grp"
        :style="{
                'min-height' : dBHeight+25+ 'px',
                'width' : 850 + 'px',
                'height' : 763 + 'px',
                'border' : 'none',
                'border-left' : 1+ 'px solid #d3d4d6',
                'background-color' : 'white'
                }"
    >
      <div>
        <div class="tb-header clear">
          <div class="tb_num fl">
            <div class="num" v-html="$i18nUtil.trans('search.000','총 {cnt}건',{cnt:totalCount})"></div>
          </div>
          <div class="tb_num fl" style="margin-left: 20px">
            <div class="ml-3" v-if="selectedRoleId !== ''" v-html="'[' + selectedRoleId + ':' + selectedRoleName + ']'"></div>
          </div>
          <div class="btnDiv fr">
            <button
              type="button"
              class="btn-primary-small"
              @click="roleUserSetting"
            >{{$i18nUtil.trans("message.RoleUserSetting.001","사용자 등록")}}
            </button>
          </div>
          <div class="search_ty2" style="float: right;padding-right: 20px;">
            <input
              type="text"
              required
              :placeholder="$i18nUtil.trans('message.RoleUserViewList.002','사용자 검색')"
              v-model="searchUser"
              @keyup.enter="[changePage(), getRoleUserList()]"
            />
            <button
              type="button"
              class="input-txt"
              @click="[changePage(), getRoleUserList()]"
            >
            {{$i18nUtil.trans("search.039","검색")}}
            </button>
          </div>                      
        </div>

        <v-data-table
        v-model="selected"
        :headers="headers"
        :items="roleUserList"
        hide-default-footer
        class="tb-contents"
        >
        <template v-slot:item="{ item }">
          <tr>
            <td>
              <div>
                <span @click="roleUserModify(item.roleId, item.expireDate, item.userId, item.userName)">
                  {{ item.roleId }}
                </span>
              </div>
            </td>
            <td>
              <div>
                <span>
                  {{ item.userName == null ? item.userId: item.userName}}
                </span>
                <!-- <span class="cursor-pointer" @click="roleUserSetting(item)">
                  {{ item.userName }}
                </span> -->
              </div>
            </td>
            <td>
              <div>
                <span>{{ item.userKbn == 1 ? $i18nUtil.trans('entity.user.user') : item.userKbn == 2 ? $i18nUtil.trans('entity.user.deptName','부서') : $i18nUtil.trans('message.project.OKR.typeElse','회사') }}</span>
              </div>
            </td>
            <td>
              <div>
                <span>{{ item.inoutKbn == 'IN' ? $i18nUtil.trans('message.RoleUserViewList.003','내부') : item.inoutKbn == 'OUT' ? $i18nUtil.trans('message.RoleUserViewList.004','외부') : $i18nUtil.trans('message.RoleUserViewList.005','모바일') }}</span>
              </div>
            </td>
            <td>
              <div>
                <span>{{ item.useYN == 1 ? $i18nUtil.trans('message.RoleManage.004','사용') : $i18nUtil.trans('message.RoleManage.005','미사용') }}</span>
              </div>
            </td>
            <td>
              <div>
                <span>{{ $moment(item.createDate).format("YYYY.MM.DD") }}</span>
              </div>
            </td>
            <td>
              <div>
              <button
                    type="button"
                    class="btn-primary-small"
                    @click="deleteRoleUser(item)"
                    style="right: -100px"
              >{{$i18nUtil.trans("button.delete","삭제")}}
              </button>
              </div>
            </td>
          </tr>
        </template>

        <template slot="no-data">
          <div class="nodata-txt-noicon">
            <v-alert :value="true">
              {{$i18nUtil.trans("message.RoleUserViewList.001","권한 사용자 리스트가 없습니다.")}}
            </v-alert>
          </div>
        </template>
        </v-data-table>

        <div v-show="pageCount > 0" class="pagination">
          <v-pagination
            v-model="page"
            circle
            :length="pageCount"
            :total-visible="7"
            @input="getRoleUserList"
          ></v-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
import RoleUserSetting from "./modal/RoleUserSetting";

export default {
    components: {
      RoleUserSetting,
    },
    props:["selectedRoleId", "selectedRoleName"],
    data() {
      return {
        dBHeight: {
        "min-height": window.innerHeight - 151 + "px",
        },
        enabled: true,
        show: false,
        page: 1,
        pageCount: 0,
        totalCount : 0, 
        itemsPerPage: 10,
        selected: [],
        roleUserList: [],
        roleId : null,
        roleName : null,
        searchUser: "",
        headers: [
            { text: this.$i18nUtil.trans('message.RoleManage.001','권한아이디'), value: 'roleId', sortable: true },
            { text: this.$i18nUtil.trans('message.RoleUserRegist.001','사용자명'), value: 'userName', sortable: false },
            { text: this.$i18nUtil.trans('message.RoleUserViewList.006','사용자구분'), value: 'userKbn', sortable: true},
            { text: this.$i18nUtil.trans('message.RoleUserViewList.007','망구분'), value: 'inoutKbn', sortable: true },
            { text: this.$i18nUtil.trans('message.RoleManage.007','사용여부'), value: 'useYn', sortable: true },
            { text: this.$i18nUtil.trans('message.RoleUserViewList.008','생성일'), value: 'createDate', sortable: false },
            { text: this.$i18nUtil.trans('button.delete','삭제'), sortable: false },
        ],
        toastInfo: {
          obj: this.$toasted,
          message: "",
          options: {
            theme: "toasted-primary",
            position: "bottom-left",
            duration: 3000,
          },
        },
      };
    },
    created() {
      EventBus.$off("registRoleUser");
      EventBus.$on("registRoleUser", param => {
        let obj = this;
        if (param.regist == true) {
          obj.getRoleUserList();
        }
      });      
    },
    watch:{
      selectedRoleId(){
        this.roleId = this.selectedRoleId;
        this.getRoleUserList();
      },
      selectedRoleName() {
        this.roleName = this.selectedRoleName;
      },
    },
    methods: {
      ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),      
      ...mapActions("modals", ["showToast", "showModal"]),
      getRoleUserList() {
        let obj = this;

        let reqData = {};
        reqData.params = {
          currentPage: obj.page,
          itemsPerPage: obj.itemsPerPage,
          searchUser: obj.searchUser,
          roleId: obj.roleId
        };
        reqData.url = "/api/org/role/getRoleUserList";
        reqData.method = "post";
        
        //프로그레스바 시작
        this.showLoadingbar();
        obj
          .COWORK_REST_SIMPLE_ACTION(reqData)
          .then((res) => {
            //프로그레스바 종료
            this.hideLoadingbar();
            if (res.errorCode) {
              console.log(res.errorCode);
            } else {
              obj.roleUserList = res.result.roleUserList;
              obj.totalCount = res.result.roleUserCount;
              obj.pageCount = res.result.roleUserPageCount;
            }
          })
          .catch((err) => {
            console.log("axios err => ", err);
          });
      },
      roleUserSetting(){
        if(this.roleId != null){
          let modalInfo = {
          width: "1220px",
          height: "500px",
          obj: this.$modal,
          status: 'regist',
          roleId: this.roleId,
          component: RoleUserSetting,
          };
          this.showModal(modalInfo);
        }
      },
      roleUserModify(roleId, expireDate, userId, userName){
        if(this.roleId != null){
            let modalInfo = {
            width: "1220px",
            height: "500px",
            obj: this.$modal,
            status: 'regist',
            roleId: roleId,
            expireDate: expireDate === undefined ? "" : expireDate,
            userId: userId,
            userName: userName,
            component: RoleUserSetting,
          };
          this.showModal(modalInfo);
        }
      },
      deleteRoleUser(item) {
        /* 사용자 삭제 */
        if (confirm(this.$i18nUtil.trans('message.RoleUserViewList.009','사용자를 삭제하시겠습니까?'))) {
          let obj = this;
          let reqData = {};
          reqData.url = "/api/org/role/deleteRoleUser";
          reqData.method = "post";
          reqData.params = {
            roleId: item.roleId,
            userId: item.userId,
            expireDate: item.expireDate.split("-").join("").substring(0,8)
          };
          //프로그레스바 시작
          this.showLoadingbar();
          obj
            .COWORK_REST_SIMPLE_ACTION(reqData)
            .then((res) => {
              //프로그레스바 종료
              this.hideLoadingbar();
              if (res.errorCode) {
                console.log(res.errorCode);
              } else {              
                obj.toastInfo.message = obj.$i18nUtil.trans('message.RoleUserViewList.010','사용자가 삭제되었습니다.');
                obj.showToast(obj.toastInfo);
                this.getRoleUserList();
              }
            })
            .catch((err) => {
              console.log("axios err => ", err);
            });
        }        
      },
      changePage() {
        this.page = 1;
      },
    }
}
</script>

<style scoped>
.task-list .card_grp.active:after, :before{
      box-sizing: inherit; 
}
.krs006 >>> tbody::after {
  display: none;
}
.krs006 >>> tbody::before {
  display: none;
}
.krs006 >>> th:nth-child(1) {
  width: 133px;
  padding-left: 29px;
}
.krs006 >>> th:nth-child(2) {
  width: 123px;
  padding-left: 28px;
}
.krs006 >>> th:nth-child(3) {
  width: 110px;
}
.krs006 >>> th:nth-child(4) {
  width: 100px;
}
.krs006 >>> th:nth-child(5) {
  width: 100px;
}
.krs006 >>> th:nth-child(6) {
  width: 133px;
}
.krs006 >>> th:nth-child(7) {
  width: 100px;
}

.krs006 >>> td:nth-child(1) {
  width: 133px;
  padding-left: 29px;
}
.krs006 >>> td:nth-child(2) {
  width: 123px;
  padding-left: 29px;
}
.krs006 >>> td:nth-child(3) {
  width: 110px;
  padding-right: 10px;
  text-align: center;
}
.krs006 >>> td:nth-child(4) {
  width: 100px;
  padding-right: 15px;
  text-align: center;
}
.krs006 >>> td:nth-child(5) {
  width: 100px;
  padding-right: 15px;
  text-align: center;
}
.krs006 >>> td:nth-child(6) {
  width: 133px;
  text-align: center;
}
.krs006 >>> td:nth-child(7) {
  width: 100px;
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/cowork/cosys/audit/base/tab/history/RoleUserViewList.vue